import { erpAxios } from '..';

const getApplication = async (id) => {
  const { data } = await erpAxios(`/loanApplication/${id}`);
  return data;
};

export default getApplication;
